import styles from "./ViewerMenu.module.css";
import { childType } from "./ViewerMenuTypes";

export const ViewerButtonLine = ({ children }: { children: childType | childType[] }) => {
  return <div className={styles.viewerButtonLine}>{children}</div>;
};
